// ===== Imports de imágenes ===== //
import WpcPisoinstalado from "./images/WPC/instalado/DeckPisoInstalado.png";
import PanelAcanaladoInstalado from "./images/WPC/instalado/PanelAcanaladoInstalado.jpeg";
import VigasInstaladas from "./images/WPC/instalado/VigaInstalada.png";
import PanelLiso from "./images/WPC/instalado/PanelLisoInstalado.png";

// Producto Instalado PVC //
import WallPanelInstalado from "./images/PVC/instalado/WEBDEKO-09.png";
import TablillaInstalada from "./images/PVC/instalado/WEBDEKO-12.png";
import TablillaOtraInstalada from "./images/PVC/instalado/WEBDEKO-11.png";

// Producto Instalado SPC //
import PisonInstalado from "./images/SPC/instalado/WEBDEKO-03.png";

// Producto Instalado DekoWall //
import calacattaInstalado from "./images/WALL/instalado/WEBDEKO-07.png";
import lisoInstalado from "./images/WALL/instalado/WEBDEKO-08.png";
import MaderaInstalada from "./images/WALL/instalado/WallPanelLisoMadera.png";

// Producto Solo WPC //
import PisoProd from "./images/WPC/producto/deckteak.png";
import AcanaladoProd from "./images/WPC/producto/acanaladoteak.png";
import LisoProd from "./images/WPC/producto/lisoteak.png";

// Import viga //
import vigaprod from "./images/WPC/producto/Viga.png";

// Producto Solo SPC //
import PisoSpcProd from "./images/SPC/producto/Rectangle-24-2.jpg";

// Producto Solo PVC //
import WallPanelProd from "./images/PVC/producto/Rectangle-28.jpg";
import TablillaProd from "./images/PVC/producto/TABLILLA-LAMINADA-3.png";
import TabillaOtraProd from "./images/PVC/producto/TABLILLA-IMPRESA-2.png";

// Producto  Solo DekoWall //
import calacattaProd from "./images/WALL/producto/proyecto-web-fotos_circulo-solo-copy-2.png";
import WallLisoProd from "./images/WALL/producto/DekoWallEspejoNegro.png";
import WallEspejoProd from "./images/WALL/producto/DekoWallEspejo.png";

// Roof
import DekoRoofProd from "./images/ROOF/DekoRoofInstalado.png";
// ProductoRoof
import DekoRoofProducto from "./images/ROOF/Producto/DEKOROOF-01.png";

// ===== Clasificación requerida (alineada a PDFs) =====
// (OJO: Si tus categorías/subcategorías se muestran en UI, traducilas con i18n aparte)
export const CATEGORY_TREE = {
  WPC: [
    { es: "Piso Deck", en: "Deck Flooring" },
    { es: "Panel Acanalado", en: "Grooved Panel" },
    { es: "Viga", en: "Beam" },
    { es: "Panel Liso", en: "Smooth Panel" },
  ],
  PVC: [
    { es: "Wall Panel", en: "Wall Panel" },
    { es: "Tablilla impresa", en: "Printed Slat" },
    { es: "Tablilla laminada", en: "Laminated Slat" },
  ],
  SPC: [{ es: "Piso", en: "Flooring" }],
  DEKOWALL: [
    { es: "Calacattas", en: "Calacatta" },
    { es: "Espejos", en: "Mirrors" },
    { es: "Liso", en: "Smooth" },
  ],
  DEKOROOF: [{ es: "Roof", en: "Roof" }],
};

// Utilidad para URLs limpias
const slugify = (s) =>
  String(s)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

// ===== Productos =====
export const PRODUCTS = {
  // ======= WPC =======
  "piso-deck-wpc": {
    slug: "piso-deck-wpc",
    title: { es: "Piso Deck WPC", en: "WPC Deck Flooring" },
    heroImage: [WpcPisoinstalado],
    description: {
      es: "Deck WPC de doble cara (liso/madera) para exteriores: resistente, moderno y de bajo mantenimiento.",
      en: "Double-sided WPC deck (smooth/wood look) for outdoor use: durable, modern, and low maintenance.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20piso%20deck%20wpc%20por%20favor.%20",
    benefits: [
      { es: "Gran durabilidad y resistencia UV", en: "High durability and UV resistance" },
      { es: "Material ecológico (reciclado)", en: "Eco-friendly (recycled) material" },
      { es: "No se astilla ni se deforma", en: "Won’t splinter or warp" },
      { es: "Impermeable y fácil de limpiar", en: "Waterproof and easy to clean" },
      { es: "Bajo mantenimiento", en: "Low maintenance" },
      { es: "Antibacteriano", en: "Antibacterial" },
    ],
    applications: [
      { es: "Balcones", en: "Balconies" },
      { es: "Terrazas", en: "Terraces" },
      { es: "Jardines", en: "Gardens" },
      { es: "Piscinas", en: "Pools" },
    ],
    compositionImage: PisoProd,
    specs: {
      Largo: "2.9 m",
      Ancho: "13.8 cm",
      Espesor: "23 mm",
      AreaPorPieza: "0.40 m²",
      Material: {
        es: "60% polvo de madera, 30% HDPE, 10% aditivos",
        en: "60% wood powder, 30% HDPE, 10% additives",
      },
      Resistencia: {
        es: "≈ 400 kg/m² (barras a 35 cm máx.)",
        en: "≈ 400 kg/m² (supports up to 35 cm max. spacing)",
      },
      Caras: {
        es: "Doble cara: liso y apariencia madera",
        en: "Double-sided: smooth and wood-look",
      },
    },
    colors: [
      { name: "IPE", hex: "#3A2E1F" },
      { name: "TEAK", hex: "#B38E6D" },
      { name: "OAK", hex: "#D4B996" },
      { name: "WALNUT", hex: "#8B6B4A" },
      { name: "DARK GRAY", hex: "#4A4A48" },
      { name: "BLACK", hex: "#2C2C2C" },
    ],
    composition: [
      { label: { es: "Polvo de madera", en: "Wood powder" }, value: 60 },
      { label: "HDPE", value: 30 },
      { label: { es: "Aditivos", en: "Additives" }, value: 10 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n",
    },
    category: "WPC",
    subcategory: "Piso Deck",
  },

  "panel-acanalado": {
    slug: "panel-acanalado",
    title: { es: "Panel Acanalado WPC", en: "WPC Grooved Panel" },
    heroImage: [PanelAcanaladoInstalado],
    description: {
      es: "Panel WPC con frente acanalado y reverso liso; oculta imperfecciones y aporta textura cálida.",
      en: "WPC panel with grooved front and smooth back; hides imperfections and adds warm texture.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20panel%20acanalado%20por%20favor.%20",
    benefits: [
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Acabado tipo madera real", en: "Real wood-like finish" },
      { es: "Antibacteriano", en: "Antibacterial" },
      { es: "Fácil mantenimiento y limpieza", en: "Easy maintenance and cleaning" },
      { es: "Resistente a climas humedos y rayos UV", en: "Resistant to humid climates and UV rays" },
    ],
    applications: [
      { es: "Paredes y cielos", en: "Walls and ceilings" },
      {
        es: "Interiores y exteriores (recomendado vertical en exterior)",
        en: "Indoor and outdoor (vertical installation recommended outdoors)",
      },
    ],
    compositionImage: AcanaladoProd,
    specs: {
      Largo: "2.9 m",
      Ancho: { es: "17 cm (15.5 cm útiles)", en: "17 cm (15.5 cm usable)" },
      Espesor: "26 mm",
      AreaPorPieza: "0.45 m²",
      Material: {
        es: "60% polvo de madera, 30% HDPE, 10% aditivos",
        en: "60% wood powder, 30% HDPE, 10% additives",
      },
      Instalacion: { es: "Clips fijados", en: "Fixed clips" },
      Peso: { es: "7.6kg por pieza", en: "7.6 kg per piece" },
    },
    colors: [
      { name: "IPE", hex: "#3A2E1F" },
      { name: "TEAK", hex: "#B38E6D" },
      { name: "OAK", hex: "#D4B996" },
      { name: "WALNUT", hex: "#8B6B4A" },
      { name: "DARK GRAY", hex: "#4A4A48" },
      { name: "BLACK", hex: "#2C2C2C" },
    ],
    composition: [
      { label: { es: "Polvo de madera", en: "Wood powder" }, value: 60 },
      { label: "HDPE", value: 30 },
      { label: { es: "Aditivos", en: "Additives" }, value: 10 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "WPC",
    subcategory: "Panel Acanalado",
  },

  "panel-liso-wpc": {
    slug: "panel-liso-wpc",
    title: { es: "Panel Liso WPC", en: "Smooth WPC Panel" },
    heroImage: [PanelLiso],
    description: {
      es: "Panel WPC liso con diseño amaderado; con acabados elegantes y resistentes.",
      en: "Smooth WPC panel with a plank look; uniform, elegant, and durable finish.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20panel%20liso%20por%20favor.%20",
    benefits: [
      { es: "Fácil de limpiar", en: "Easy to clean" },
      { es: "Apariencia madera real", en: "Real wood-like appearance" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Resistencia a la interperie", en: "Weather-resistant" },
      { es: "Antibacteriano", en: "Antibacterial" },
    ],
    applications: [
      { es: "Paredes, cielos y portones", en: "Walls and ceilings" },
      { es: "Casas, apartamentos y oficinas", en: "Homes, apartments, and offices" },
    ],
    compositionImage: LisoProd,
    specs: {
      Largo: "2.9 m",
      Ancho: { es: "16.45 cm (16.30 cm útiles)", en: "16.45 cm (16.30 cm usable)" },
      Espesor: "21 mm",
      Peso: { es: "5.3kg por pieza", en: "5.3 kg per piece" },
        AreaPorPieza: {
    es: "0.48 m² (16.3 cm × 2.9 m)",
    en: "0.48 m² (16.3 cm × 2.9 m)",
  },
      Material: {
        es: "60% polvo de madera, 30% HDPE, 10% aditivos",
        en: "60% wood powder, 30% HDPE, 10% additives",
      },
    },
    colors: [
      { name: "IPE", hex: "#3A2E1F" },
      { name: "TEAK", hex: "#B38E6D" },
      { name: "OAK", hex: "#D4B996" },
      { name: "WALNUT", hex: "#8B6B4A" },
      { name: "DARK GRAY", hex: "#4A4A48" },
      { name: "BLACK", hex: "#2C2C2C" },
       {
    name: { es: "CEDRO", en: "CEDAR" },
    finish: "wood",
    gradient: {
      angle: 135,
      stops: ["#8A3F1F", "#9B4A25", "#A9562B", "#B25F30", "#BC6938"],
    },
  },
  {
    name: { es: "NOGAL", en: "WALNUT" },
    finish: "wood",
    gradient: {
      angle: 135,
      stops: ["#5B3A23", "#644029", "#6E472F", "#784F36", "#82573D"],
    },
  },
    ],
    composition: [
      { label: { es: "Polvo de madera", en: "Wood powder" }, value: 60 },
      { label: "HDPE", value: 30 },
      { label: { es: "Aditivos", en: "Additives" }, value: 10 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "WPC",
    subcategory: "Panel Liso",
  },

  "vigas-wpc": {
    slug: "vigas-wpc",
    title: { es: "Vigas / Perfiles WPC", en: "WPC Beams / Profiles" },
    heroImage: [VigasInstaladas],
    description: {
      es: "Perfiles decorativos WPC huecos; livianos, de apariencia madera y fácil montaje.",
      en: "Hollow decorative WPC profiles; lightweight, wood-like appearance, and easy to install.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20de%20vigas%20wpc%20por%20favor.%20",
    benefits: [
      { es: "Resistencia al agua", en: "Water-resistant" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Estética tipo madera", en: "Wood-like aesthetics" },
      { es: "Antibacteriano", en: "Antibacterial" },
      { es: "Barra de aluminio interna", en: "Internal metal bar" },
    ],
    applications: [
      { es: "Fachadas y cielos", en: "Facades and ceilings" },
      { es: "Paredes decorativas", en: "Decorative walls" },
      { es: "Terrazas y mamparas en separación", en: "Terraces and partition screens" },
      { es: "Interior y exterior bajo techo", en: "Indoor and covered outdoor areas" },
    ],
specs: {
  Diseño: {
    es: "Liso por los cuatro costados, se asemeja a una viga de madera",
    en: "Smooth on all four sides, similar to a wooden beam",
  },

  Dimenciones: [
    {
      es: "Viga 100 × 50 mm — Largo: 2.9 m · Ancho: 10 cm · Grosor: 5 cm",
      en: "Beam 100 × 50 mm — Length: 2.9 m · Width: 10 cm · Thickness: 5 cm",
    },
    {
      es: "Viga 60 × 40 mm — Largo: 2.9 m · Ancho: 6 cm · Grosor: 4 cm",
      en: "Beam 60 × 40 mm — Length: 2.9 m · Width: 6 cm · Thickness: 4 cm",
    },
    {
      es: "Viga 80 × 40 mm — Largo: 2.9 m · Ancho: 8 cm · Grosor: 4 cm",
      en: "Beam 80 × 40 mm — Length: 2.9 m · Width: 8 cm · Thickness: 4 cm",
    },
  ],

  Material: {
    es: "60% polvo de madera, 30% HDPE, 10% aditivos",
    en: "60% wood powder, 30% HDPE, 10% additives",
  },
  Estructura: {
    es: "Viga hueca (Con barra de aluminio interna)",
    en: "Hollow beam (not filled with an internal metal bar)",
  },
  Instalacion: {
    es: "Clip metálico tipo C",
    en: "C-type metal clip",
  },
},
    colors: [
      { name: "IPE", hex: "#3A2E1F" },
      { name: "TEAK", hex: "#B38E6D" },
      { name: "OAK", hex: "#D4B996" },
      { name: "WALNUT", hex: "#8B6B4A" },
      { name: "DARK GRAY", hex: "#4A4A48" },
      { name: "BLACK", hex: "#2C2C2C" },
    ],
    compositionImage: vigaprod,
    composition: [
      { label: { es: "Polvo de madera", en: "Wood powder" }, value: 60 },
      { label: "HDPE", value: 30 },
      { label: { es: "Aditivos", en: "Additives" }, value: 10 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "WPC",
    subcategory: "Viga",
  },

  // ======= PVC =======
  "wall-panel-pvc": {
    slug: "wall-panel-pvc",
    title: { es: "Wall Panel PVC", en: "PVC Wall Panel" },
    heroImage: [WallPanelInstalado],
    description: {
      es: "Lamina PVC liviana para pares y cielos en interiores: limpio, versátil y resistente a humedad.",
      en: "Lightweight PVC panel for indoor walls: clean, versatile, and moisture-resistant.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20wall%20panel%20pvc%20por%20favor.%20",
    benefits: [
      { es: "Fácil instalación", en: "Easy installation" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Apariencia amaderada", en: "Wood-look finish" },
    ],
    applications: [
      { es: "Ideal para interiores", en: "Ideal for interiors" },
      {
        es: "Salas, comedores, dormitorios, oficinas, comercios, hoteles",
        en: "Living rooms, dining rooms, bedrooms, offices, retail spaces, hotels",
      },
      {
        es: "Paredes de acento, cabeceras, cielos o fondos decorativos",
        en: "Accent walls, headboards, or decorative backgrounds",
      },
    ],
    specs: {
      Largo: "2.9 m",
      Ancho: "16 cm",
      Espesor: "2.4 cm",
      Caja: { es: "10 unidades (se vende por unidad)", en: "10 units (sold per unit)" },
      Material: "100% PVC",
    },
    compositionImage: WallPanelProd,
    colors: [
      { name: { es: "ROBLE", en: "OAK" }, hex: "#3A2E1F" },
      { name: "WOOD GRAY", hex: "#B38E6D" },
      { name: { es: "BLANCO MATE", en: "MATTE WHITE" }, hex: "#D4B996" },
      { name: { es: "ALMENDRO", en: "ALMOND" }, hex: "#8B6B4A" },
      { name: "CALACATTA", hex: "#4A4A48" },
      { name: { es: "NEGRO MATE", en: "MATTE BLACK" }, hex: "#2C2C2C" },
    ],
    composition: [
      { label: { es: "Policloruro de vinilo", en: "Polyvinyl chloride" }, value: 75 },
      { label: { es: "Sal", en: "Salt" }, value: 10 },
      { label: { es: "Cal", en: "Lime" }, value: 10 },
      { label: { es: "Estabilizador", en: "Stabilizer" }, value: 5 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "PVC",
    subcategory: "Wall Panel",
  },

  "tablilla-impresa-pvc": {
    slug: "tablilla-impresa-pvc",
    title: { es: "Tablilla Impresa PVC", en: "Printed PVC Panel" },
    heroImage: [TablillaInstalada],
    description: {
      es: "Tablillas impresas en PVC: variedad de diseños, formato práctico y estetico para revestir cielos en interiores.",
      en: "Printed PVC panels: a variety of designs, practical format, and hassle-free installation.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20de%20tablilla%20impresa%20pvc%20por%20favor.%20",
    benefits: [
      { es: "Aislante acústico", en: "Acoustic insulation" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Vida útil prolongada", en: "Long service life" },
      { es: "No requiere acabados ni mantenimientos", en: "No finishing or maintenance required" },
      { es: "Resistente a humedad, salinidad e insectos", en: "Resistant to moisture, salinity, and insects" },
    ],
    applications: [
      { es: "Ideal para cielorraso de interiores", en: "Ideal for indoor ceilings" },
      {
        es: "Salas, Comedores, Dormitorios, Oficinas, Locales comerciales",
        en: "Living rooms, dining rooms, bedrooms, offices, retail spaces",
      },
    ],
    compositionImage: TabillaOtraProd,
    specs: {
      Largo: "595 cm",
      Ancho: "25 cm",
      Espesor: "6.5 mm",
      Cubrimiento: { es: "1.4875 m² por tabla", en: "1.4875 m² per panel" },
      Empaque: { es: "10 unidades (venta por unidad)", en: "10 units (sold per unit)" },
      Material: "PVC",
    },
    colors: [
      {
        name: { es: "BLANCO BRILLANTE CON DIVISIÓN", en: "GLOSSY WHITE WITH DIVISION" },
        gradient: { angle: 135, stops: ["#CFD7E9", "#CFD8E9", "#D2DBEC"] },
      },
      {
        name: { es: "FRESNO BRILLANTE", en: "GLOSSY ASH" },
        gradient: { angle: 135, stops: ["#968863", "#AB9E77", "#B1A47E", "#B7AA84", "#C2B593"] },
      },
      {
        name: { es: "BLANCO BRILLANTE", en: "GLOSSY WHITE" },
        gradient: { angle: 135, stops: ["#C9D5ED", "#C9D5ED", "#CAD6EE"] },
      },
      {
        name: { es: "OAK BRILLANTE", en: "GLOSSY OAK" },
        gradient: { angle: 135, stops: ["#4C2113", "#5A2D14", "#653614", "#704015", "#7F4E16"] },
      },
      {
        name: { es: "CENÍZARO MATE", en: "MATTE ASH WOOD" },
        gradient: { angle: 135, stops: ["#7A522F", "#976F46", "#A57E52", "#AE885C", "#BC956B"] },
      },
      {
        name: { es: "BLANCO MATE", en: "MATTE WHITE" },
        gradient: { angle: 135, stops: ["#C9D5ED", "#C9D5ED", "#CAD6EE"] },
      },
      {
        name: { es: "WOOD GRIS MATE", en: "MATTE GRAY WOOD" },
        gradient: { angle: 135, stops: ["#C5CCDD", "#CDD4E7", "#CFD7E9", "#D2D9EB", "#D3DCED"] },
      },
    ],
    composition: [
      { label: { es: "Policloruro de vinilo", en: "Polyvinyl chloride" }, value: 75 },
      { label: { es: "Sal", en: "Salt" }, value: 10 },
      { label: { es: "Cal", en: "Lime" }, value: 10 },
      { label: { es: "Estabilizador", en: "Stabilizer" }, value: 5 },
    ],
    accesorios: [
      { es: "Corniza Print (5950 × 40 mm)", en: "Printed Cornice (5950 × 40 mm)" },
      { es: "Moldura Print / Terminal Jota (5950 × 40 mm)", en: "Printed Molding / J End Trim (5950 × 40 mm)" },
      { es: "Unión Print (5950 × 40 mm)", en: "Printed Joint (5950 × 40 mm)" },
      { es: "Esquina Externa Print (5950 × 40 mm)", en: "Printed External Corner (5950 × 40 mm)" },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "PVC",
    subcategory: "Tablilla impresa",
  },

  "tablilla-laminada-pvc": {
    slug: "tablilla-laminada-pvc",
    title: { es: "Tablilla Laminada PVC", en: "Laminated PVC Panel" },
    heroImage: [TablillaOtraInstalada],
    description: {
      es: "Tablillas laminadas en PVC: variedad de diseños, formato práctico y estetico para revestir cielos en interiores.",
      en: "Laminated PVC panels for walls and ceilings: uniform finish with no wet construction.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20de%20tablilla%20laminada%20pvc%20por%20favor.%20",
    benefits: [
      { es: "Fácil instalación", en: "Easy installation" },
      { es: "Aislante acústico", en: "Acoustic insulation" },
      { es: "Vida útil prolongada", en: "Long service life" },
      { es: "Resistencia a la humedad e insectos", en: "Resistant to moisture and insects" },
      { es: "No requiere acabados ni mantenimientos", en: "No finishing or maintenance required" },
      { es: "Aspecto similar a la madera", en: "Wood-like appearance" },
    ],
    compositionImage: TablillaProd,
    applications: [
      { es: "Ideal para cielorraso de interiores", en: "Ideal for indoor ceilings" },
      {
        es: "Salas, Comedores, Dormitorios, Oficinas, Locales comerciales",
        en: "Living rooms, dining rooms, bedrooms, offices, retail spaces",
      },
    ],
    specs: {
      Largo: "595 cm",
      Ancho: "25 cm",
      Espesor: "6.5 mm",
      Cubrimiento: { es: "1.4875 m² por tabla", en: "1.4875 m² per panel" },
      Empaque: { es: "10 unidades (venta por unidad)", en: "10 units (sold per unit)" },
      Material: "PVC",
    },
    colors: [
      { name: { es: "ROBLE", en: "OAK" }, gradient: { angle: 135, stops: ["#20110A", "#26160D", "#2A190F", "#2D1B11", "#322218"] } },
      { name: { es: "ALMENDRO", en: "ALMOND" }, gradient: { angle: 135, stops: ["#352613", "#3D2D18", "#42321D", "#483824", "#50402D"] } },
      { name: { es: "OLMO", en: "ELM" }, gradient: { angle: 135, stops: ["#837F78", "#87837D", "#8B8881", "#908D85", "#93908A"] } },
      { name: { es: "BLANCO MATE", en: "MATTE WHITE" }, gradient: { angle: 135, stops: ["#CFD7E7", "#CFD8E7", "#D0D8E7"] } },
      { name: { es: "TEAK", en: "TEAK" }, gradient: { angle: 135, stops: ["#67340C", "#703B0E", "#76410F", "#7B4711", "#855214"] } },
    ],
    composition: [
      { label: { es: "Policloruro de vinilo", en: "Polyvinyl chloride" }, value: 75 },
      { label: { es: "Sal", en: "Salt" }, value: 10 },
      { label: { es: "Cal", en: "Lime" }, value: 10 },
      { label: { es: "Estabilizador", en: "Stabilizer" }, value: 5 },
    ],
    accesorios: [
      { es: "Corniza Laminada (5950 × 40 mm)", en: "Laminated Cornice (5950 × 40 mm)" },
      { es: "Moldura Laminada / Terminal Jota (5950 × 40 mm)", en: "Laminated Molding / J End Trim (5950 × 40 mm)" },
      { es: "Unión Laminada (5950 × 40 mm)", en: "Laminated Joint (5950 × 40 mm)" },
      { es: "Esquina Externa Laminada (5950 × 40 mm)", en: "Laminated External Corner (5950 × 40 mm)" },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "PVC",
    subcategory: "Tablilla laminada",
  },

  // ======= SPC =======
  "piso-spc": {
    slug: "piso-spc",
    title: { es: "Piso SPC", en: "SPC Flooring" },
    heroImage: [PisonInstalado],
    description: {
      es: "Piso laminado SPC, con sistema click, acustico, repelente a liquidos y fácil mantenimiento.",
      en: "Rigid SPC flooring, 100% waterproof with click system, quiet, and easy to maintain.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20piso%20spc%20por%20favor.%20",
    benefits: [
      { es: "Antideslizante", en: "Anti-slip" },
      { es: "Fácil instalación", en: "Easy installation" },
      { es: "Repelente a fuegos y líquidos", en: "Fire-resistant and liquid-repellent" },
      { es: "Fácil limpieza y bajo sonido", en: "Easy to clean and low noise" },
    ],
    applications: [
      { es: "Instalación solo en interiores", en: "Ideal for residential and commercial interiors" },
      {
        es: "Aplicaciones en hogares, centros comerciales, oficinas",
        en: "Used in living rooms, dining rooms, bedrooms, offices, retail spaces",
      },
    ],
    compositionImage: PisoSpcProd,
    specs: {
      Largo: "154 cm",
      Ancho: "23 cm",
      Espesor: "6 mm",
      Cajas: { es: "6 piezas por cajas", en: "6 pieces per box" },
      Peso: { es: "≈ 3.7 kg por pieza", en: "≈ 3.7 kg per piece" },
      Cobertura: "2.21252 m² por caja",
      Precauciones: {
        es: "No usar en garajes/duchas/terrazas; sillas con ruedas de goma; no lavar con abundante agua",
        en: "Do not use in garages/showers/terraces; use rubber wheels on chairs; do not wash with large amounts of water",
      },
    },
    accesorios: [
      { es: "Espuma base 16.9 m × 1.1 m × 2 mm (18.6 m²/rollo)", en: "Underlayment foam 16.9 m × 1.1 m × 2 mm (18.6 m²/roll)" },
      { es: "Rodapié 2400×60×12 mm", en: "Baseboard 2400×60×12 mm" },
      { es: "Unión en T 2400×45×6 mm", en: "T-molding 2400×45×6 mm" },
      { es: "Reductor 2400×45×8 mm", en: "Reducer 2400×45×8 mm" },
      { es: "Borde de escalera 2400×55×18 mm", en: "Stair nose 2400×55×18 mm" },
      { es: "Cuarto redondo 2400×28×15 mm", en: "Quarter round 2400×28×15 mm" },
    ],
    colors: [
      { name: { es: "TAUPE", en: "TAUPE" }, gradient: { angle: 135, stops: ["#6F665B", "#756C60", "#7A7166", "#7F776B", "#857E72"] } },
      { name: { es: "SMOKE", en: "SMOKE" }, gradient: { angle: 135, stops: ["#5F5F61", "#666668", "#6B6C6E", "#717274", "#77787A"] } },
      { name: { es: "NUEZ", en: "WALNUT" }, gradient: { angle: 135, stops: ["#8C6A3F", "#957247", "#9C7A4E", "#A38256", "#AB8B5F"] } },
      { name: { es: "PERLA", en: "PEARL" }, gradient: { angle: 135, stops: ["#A7A39B", "#ADAAA2", "#B3B0A8", "#B8B6AE", "#BEBCB5"] } },
      { name: { es: "GRIS", en: "GRAY" }, gradient: { angle: 135, stops: ["#8A8A88", "#90908E", "#959593", "#9B9B99", "#A1A1A0"] } },
      { name: { es: "TABACO", en: "TOBACCO" }, gradient: { angle: 135, stops: ["#6B3F1E", "#744724", "#7C4F29", "#84582F", "#8E6336"] } },
    ],
    composition: [
      { label: { es: "Piedra Caliza", en: "Limestone" }, value: 75 },
      { label: { es: "Polvo PVC", en: "PVC powder" }, value: 25 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "SPC",
    subcategory: "Piso",
  },

  // ======= DEKOWALL =======
  "dekowall-calacatta": {
    slug: "dekowall-calacatta",
    title: { es: "DEKOWALL · Calacattas", en: "DEKOWALL · Calacatta" },
    heroImage: [calacattaInstalado],
    description: {
      es: "Láminas tipo mármol (alto brillo) para paredes y cielos en interiores; elegantes, duraderos y fáciles de instalar.",
      en: "High-gloss marble-look sheets for indoor walls; elegant, durable, and easy to install.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20dekowall%20calacattask%20por%20favor.%20",
    benefits: [
      { es: "Eco-friendly", en: "Eco-friendly" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Variedad de diseños", en: "Wide variety of designs" },
      { es: "Aislamiento térmico y acústico", en: "Thermal and acoustic insulation" },
      { es: "Resistente al agua e insectos", en: "Resistant to water and insects" },
      { es: "Instalación rápida con adhesivo", en: "Fast installation with adhesive" },
    ],
    applications: [
      { es: "Casas", en: "Homes" },
      { es: "Hospitales", en: "Hospitals" },
      { es: "Restaurantes", en: "Restaurants" },
      { es: "Oficinas", en: "Offices" },
    ],
    compositionImage: calacattaProd,
    specs: {
      Largo: "290 cm",
      Ancho: "122 cm",
      Espesor: "3 mm",
      Peso: { es: "≈ 22.34 kg/lámina", en: "≈ 22.34 kg/sheet" },
      Composicion: { es: "42% CaCO3, 50% PVC, 8% aditivos", en: "42% CaCO3, 50% PVC, 8% additives" },
      VidaUtil: { es: "10 años útiles", en: "10 years of service life" },
      Instalacion: { es: "Pegamento estructural sobre muro preparado", en: "Structural adhesive over a prepared wall" },
    },
    colors: [
      { name: { es: "CARRARA", en: "CARRARA" }, gradient: { angle: 135, stops: ["#E9E9E7", "#E1E1DF", "#D7D7D5"] }, veins: { dark: "rgba(120,125,135,0.35)", mid: "rgba(160,165,175,0.22)" } },
      { name: { es: "STATUARIO", en: "STATUARIO" }, gradient: { angle: 135, stops: ["#ECECE9", "#E3E3E0", "#D9D9D6"] }, veins: { dark: "rgba(110,115,125,0.45)", mid: "rgba(155,160,170,0.25)" } },
      { name: { es: "LUXURY", en: "LUXURY" }, gradient: { angle: 135, stops: ["#E2E3DE", "#D6D7D2", "#C7C8C3"] }, veins: { dark: "rgba(95,100,110,0.35)", mid: "rgba(140,145,155,0.22)" } },
      { name: { es: "GOLD", en: "GOLD" }, gradient: { angle: 135, stops: ["#E6E0D5", "#D6D0C6", "#C4BEB4"] }, veins: { dark: "rgba(170,135,85,0.45)", mid: "rgba(195,165,120,0.28)" } },
      { name: { es: "VENECIA", en: "VENECIA" }, gradient: { angle: 135, stops: ["#DADBD8", "#CDCECA", "#BEBFBB"] }, veins: { dark: "rgba(115,120,130,0.35)", mid: "rgba(150,155,165,0.22)" } },
      { name: { es: "BLACK MARQUINA", en: "BLACK MARQUINA" }, gradient: { angle: 135, stops: ["#1B1A19", "#242322", "#2F2D2C"] }, veins: { dark: "rgba(255,255,255,0.30)", mid: "rgba(210,210,210,0.18)" } },
      { name: { es: "PANDA", en: "PANDA" }, gradient: { angle: 135, stops: ["#E7E7E5", "#DADAD8", "#C8C8C6"] }, veins: { dark: "rgba(35,35,35,0.55)", mid: "rgba(90,90,90,0.25)" } },
      { name: { es: "STATUARIO GOLD", en: "STATUARIO GOLD" }, gradient: { angle: 135, stops: ["#E7E2D7", "#D6D1C6", "#C2BDB2"] }, veins: { dark: "rgba(175,145,95,0.45)", mid: "rgba(205,175,125,0.28)" } },
      { name: { es: "ROCK GRAY", en: "ROCK GRAY" }, gradient: { angle: 135, stops: ["#BFC0BC", "#AFAFAB", "#9C9D99"] }, veins: { dark: "rgba(80,85,90,0.35)", mid: "rgba(120,125,130,0.22)" } },
      { name: { es: "ONICE PERLA", en: "PEARL ONYX" }, gradient: { angle: 135, stops: ["#DEDCD5", "#CFCBC3", "#B8B4AC"] }, veins: { dark: "rgba(135,120,100,0.35)", mid: "rgba(175,160,140,0.22)" } },
    ],
    composition: [
      { label: { es: "Aditivos", en: "Additives" }, value: 8 },
      { label: { es: "Resina de PVC", en: "PVC resin" }, value: 50 },
      { label: { es: "Carbonato de calcio CaCO3", en: "Calcium carbonate CaCO3" }, value: 42 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "DEKOWALL",
    subcategory: "Calacattas",
  },

  "dekowall-espejos": {
    slug: "dekowall-espejos",
    title: { es: "DEKOWALL · Espejos", en: "DEKOWALL · Mirrors" },
    heroImage: [lisoInstalado],
    description: {
      es: "Láminas DEKOWALL con acabado espejo (Silver/Black) para muros interiores modernos.",
      en: "DEKOWALL sheets with mirror finish (Silver/Black) for modern indoor walls.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20dekowall%20espejos%20por%20favor.%20",
    benefits: [
      { es: "Eco-friendly", en: "Eco-friendly" },
      { es: "Aislamiento térmico y acústico", en: "Thermal and acoustic insulation" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Impermeable", en: "Waterproof" },
      { es: "Impacto visual alto", en: "High visual impact" },
      { es: "Instalación rápida", en: "Quick installation" },
    ],
    applications: [
      { es: "Casas", en: "Homes" },
      { es: "Hospitales", en: "Hospitals" },
      { es: "Restaurantes", en: "Restaurants" },
      { es: "Oficinas", en: "Offices" },
    ],
    specs: {
      Largo: "290 cm",
      Ancho: "122 cm",
      Espesor: "5 mm",
      Peso: { es: "11.5 kg/lámina", en: "11.5 kg/sheet" },
      Composicion: { es: "60% Bambú, 35% PVC, 5% aditivos", en: "60% bamboo, 35% PVC, 5% additives" },
      VidaUtil: { es: "10 años útiles", en: "10 years of service life" },
      Instalacion: { es: "Pegamento estructural sobre muro preparado", en: "Structural adhesive over a prepared wall" },
    },
    compositionImage: WallLisoProd,
    colors: [
      { name: { es: "MIRROR SILVER", en: "MIRROR SILVER" }, mirror: { base: "#C9CDD3", highlight: "rgba(255,255,255,0.85)", mid: "rgba(255,255,255,0.35)", shadow: "rgba(0,0,0,0.35)" } },
      { name: { es: "MIRROR BLACK", en: "MIRROR BLACK" }, mirror: { base: "#0C0F14", highlight: "rgba(255,255,255,0.45)", mid: "rgba(255,255,255,0.10)", shadow: "rgba(0,0,0,0.85)" } },
    ],
    composition: [
      { label: { es: "Aditivos", en: "Additives" }, value: 5 },
      { label: { es: "Resina de PVC", en: "PVC resin" }, value: 35 },
      { label: { es: "Polvo de bambú", en: "Bamboo powder" }, value: 60 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "DEKOWALL",
    subcategory: "Espejos",
  },

  "dekowall-liso": {
    slug: "dekowall-liso",
    title: { es: "DEKOWALL · Liso", en: "DEKOWALL · Smooth" },
    heroImage: [MaderaInstalada],
    description: {
      es: "Láminas DEKOWALL para muros interiores con acabado liso y diseños decorativos.",
      en: "DEKOWALL sheets for indoor walls with a smooth finish and decorative designs.",
    },
    ctaText: { es: "Cotizar", en: "Get a quote" },
    ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20dekowall%20liso%20por%20favor.%20",
    benefits: [
      { es: "Eco-friendly", en: "Eco-friendly" },
      { es: "Aislamiento térmico y acústico", en: "Thermal and acoustic insulation" },
      { es: "Retardante al fuego", en: "Fire-retardant" },
      { es: "Impermeable", en: "Waterproof" },
      { es: "Impacto visual alto", en: "High visual impact" },
      { es: "Instalación rápida", en: "Quick installation" },
    ],
    applications: [
      { es: "Casas", en: "Homes" },
      { es: "Hospitales", en: "Hospitals" },
      { es: "Restaurantes", en: "Restaurants" },
      { es: "Oficinas", en: "Offices" },
    ],
    specs: {
      Largo: "290 cm",
      Ancho: "122 cm",
      Espesor: "5 mm",
      Peso: { es: "11.5 kg/lámina", en: "11.5 kg/sheet" },
      Composicion: { es: "60% Bambú, 35% PVC, 5% aditivos", en: "60% bamboo, 35% PVC, 5% additives" },
      VidaUtil: { es: "10 años útiles", en: "10 years of service life" },
      Certificaciones: {
        es: "Sin plomo, libre de formaldehído, retardante de fuego",
        en: "Lead-free, formaldehyde-free, fire-retardant",
      },
      Instalacion: { es: "Pegamento estructural sobre muro preparado", en: "Structural adhesive over a prepared wall" },
    },
    compositionImage: WallEspejoProd,
    colors: [
      { name: { es: "ALMENDRO", en: "ALMOND" }, finish: "wood", gradient: { angle: 135, stops: ["#C7A27E", "#D1B08C", "#D8BA96", "#DFC29E", "#E6CAA6"] } },
      { name: { es: "OAK", en: "OAK" }, finish: "wood", gradient: { angle: 135, stops: ["#A48F7B", "#B09C88", "#B8A492", "#C1AD9A", "#CAB6A3"] } },
      { name: { es: "ROBLE", en: "OAK (DARK)" }, finish: "wood", gradient: { angle: 135, stops: ["#4B3A34", "#54423B", "#5B4942", "#63514A", "#6A5851"] } },
      { name: { es: "METAL SILVER", en: "METAL SILVER" }, finish: "metal", gradient: { angle: 135, stops: ["#AEB5C6", "#B8BFCE", "#C0C7D6", "#C7CEDC", "#D0D6E2"] } },
      { name: { es: "GRAY", en: "GRAY" }, finish: "metal", gradient: { angle: 135, stops: ["#6F6F72", "#77777A", "#7E7E81", "#868689", "#8E8E91"] } },
      { name: { es: "BLACK SATIN", en: "BLACK SATIN" }, finish: "satin", gradient: { angle: 135, stops: ["#050505", "#0B0B0B", "#111111", "#171717", "#1D1D1D"] } },
      { name: { es: "MARFIL", en: "IVORY" }, finish: "stone", gradient: { angle: 135, stops: ["#AFA89D", "#B5AEA3", "#B9B2A7", "#BFB8AD", "#C5BEB3"] } },
      { name: { es: "BEIGE", en: "BEIGE" }, finish: "stone", gradient: { angle: 135, stops: ["#B79F7B", "#BCA581", "#C0AA86", "#C6B18E", "#CBB693"] } },
      { name: { es: "OCRE", en: "OCHRE" }, finish: "stone", gradient: { angle: 135, stops: ["#7B4E3A", "#855642", "#8D5C47", "#95624D", "#9E6A55"] } },
    ],
    composition: [
      { label: { es: "Aditivos", en: "Additives" }, value: 5 },
      { label: { es: "Resina de PVC", en: "PVC resin" }, value: 35 },
      { label: { es: "Polvo de bambú", en: "Bamboo powder" }, value: 60 },
    ],
    contact: {
      catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
      advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
    },
    category: "DEKOWALL",
    subcategory: "Liso",
  },

  // ======= DEKOROOF =======
"deko-roof": {
  slug: "deko-roof",
  title: { es: "DEKOROOF · Techo", en: "DEKOROOF · Roofing" },
  heroImage: [DekoRoofProd],
  description: {
    es: "Láminas tipo techo para exteriores; elegantes, durables y fáciles de instalar.",
    en: "Roofing sheets for outdoor use; elegant, durable, and easy to install.",
  },
  ctaText: { es: "Cotizar", en: "Get a quote" },
  ctaHref: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20deko%20roof%20por%20favor.%20",

  benefits: [
    { es: "Eco-friendly", en: "Eco-friendly" },
    { es: "Reducción de ruido", en: "Noise reduction" },
    { es: "Resistente al agua", en: "Water-resistant" },
    { es: "Retardante al fuego", en: "Fire-retardant" },
    { es: "Baja transmisión de color", en: "Low color fading" },
    { es: "No se oxida", en: "Doesn't rust" },
    { es: "Instalación rápida", en: "Fast installation" },
  ],

  applications: [
    { es: "Bodegas industriales", en: "Industrial facilities" }, // ✅ typo fix
    { es: "Casas de habitación", en: "Residential homes" },
    { es: "Hangares", en: "Hangars" },
    { es: "Centros comerciales", en: "Shopping centers" },
    { es: "Infraestructura agropecuaria", en: "Agricultural infrastructure" },
  ],

  compositionImage: DekoRoofProducto,

  // ✅ BASE (Industrial White)
  specs: {
    Largo: { es: "11.80 m", en: "11.80 m" },
    Ancho: { es: "1075 mm", en: "1075 mm" },
    AnchoUtil: { es: "1000 mm", en: "1000 mm" },
    Espesor: "2.5 mm",
    PesoResiste: { es: "150 kg/m²", en: "150 kg/m²" },
    PesoPorM2: { es: "5.25 kg/m²", en: "5.25 kg/m²" },
    Peso: { es: "66.6 kg (lámina 11.8 m)", en: "66.6 kg (11.8 m sheet)" },

    Composicion: {
      es: "57% PVC, 36% Calcio, 5% Material ASA, 2% otros",
      en: "57% PVC, 36% Calcium, 5% ASA material, 2% others",
    },
    VidaUtil: { es: "20 años", en: "20 years" },
    Certificaciones: {
      es: "Retardante al fuego, Reducción de ruido, Aislante térmico, No se oxidan.",
      en: "Fire-retardant, noise reduction, thermal insulation, non-corrosive.",
    },
    Instalacion: {
      es: "Tornillo sobre estructura.",
      en: "Screws over structure.",
    },
  },

  // ✅ Para tabla por renglones usa ESTO (specsOverride por color)
  colors: [
    {
      id: "industrial-white",
      name: { es: "BLANCO", en: "INDUSTRIAL WHITE" },
      finish: "solid",
      gradient: { angle: 180, stops: ["#F4F6F8", "#EDEFF2", "#E6E9ED"] },
      specsOverride: {}, // coincide con base
    },
    {
      id: "industrial-clear",
      name: { es: "TRASPARENTE", en: "INDUSTRIAL CLEAR" },
      translucent: {
        base: "rgba(255,255,255,0.45)",
        edge: "rgba(255,255,255,0.75)",
        shadow: "rgba(0,0,0,0.18)",
      },
      specsOverride: {
        Espesor: "1.8 mm",
        PesoResiste: { es: "100 kg/m²", en: "100 kg/m²" },
        PesoPorM2: { es: "2.97 kg/m²", en: "2.97 kg/m²" },
        Peso: {
          es: "37.67 kg (lámina 11.8 m)",
          en: "37.67 kg (11.8 m sheet)",
        },
      },
    },
    {
      id: "pared-white",
      name: { es: "PARED BLANCA", en: "WALL WHITE" },
      finish: "solid",
      gradient: { angle: 180, stops: ["#F4F6F8", "#EEF1F4", "#E7EBEF"] },
      specsOverride: {
        Ancho: { es: "1029 mm", en: "1029 mm" },
        AnchoUtil: { es: "970 mm", en: "970 mm" },
        Espesor: "2.0 mm",
        PesoResiste: { es: "150 kg/m²", en: "150 kg/m²" },
        PesoPorM2: { es: "4.2 kg/m²", en: "4.2 kg/m²" },
        Peso: { es: "51 kg (lámina 11.8 m)", en: "51 kg (11.8 m sheet)" },
      },
    },
    {
      id: "teja-terracota",
      name: { es: "TEJA TERRACOTA", en: "TERRACOTTA" },
      finish: "stone",
      gradient: {
        angle: 135,
        stops: ["#8C3F2B", "#9A4A33", "#A6533A", "#B05E43", "#BA684D"],
      },
      specsOverride: {
        Ancho: { es: "1050 mm", en: "1050 mm" },
        AnchoUtil: { es: "960 mm", en: "960 mm" },
        Espesor: "2.5 mm",
        PesoResiste: { es: "150 kg/m²", en: "150 kg/m²" },
        PesoPorM2: { es: "5.25 kg/m²", en: "5.25 kg/m²" },
        Peso: {
          es: "63.28 kg (lámina 11.8 m)",
          en: "63.28 kg (11.8 m sheet)",
        },
      },
    },
  ],

  composition: [
    { label: "ASA", value: 5 },
    { label: { es: "Aditivos", en: "Additives" }, value: 2 },
    { label: { es: "Resina de PVC", en: "PVC resin" }, value: 57 },
    {
      label: { es: "Carbonato de calcio CaCO3", en: "Calcium carbonate CaCO3" },
      value: 36,
    },
  ],

  contact: {
    catalog: "https://flipbooks.gruposantamaria.cr/flipbook1",
    advisor: "https://wa.me/50661686664?text=%C2%A1Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n%",
  },

  category: "DEKOROOF",
  subcategory: "Roof",
},
};

// =====================
// Helpers (localización i18n)
// =====================
const isLangObj = (v) =>
  v && typeof v === "object" && !Array.isArray(v) && ("es" in v || "en" in v);

const normalizeLang = (lang = "es") =>
  String(lang).toLowerCase().startsWith("en") ? "en" : "es";

const pickLang = (v, lang = "es") => {
  const L = normalizeLang(lang);
  if (isLangObj(v)) return v[L] ?? v.es ?? v.en ?? "";
  return v;
};

const pickArray = (arr, lang) =>
  Array.isArray(arr) ? arr.map((x) => pickLang(x, lang)) : arr;

const mapColors = (colors, lang) => {
  const L = normalizeLang(lang);
  if (!Array.isArray(colors)) return colors;

  return colors
    .map((c) => {
      if (typeof c === "string") return { name: c };

      if (isLangObj(c)) return { name: c[L] ?? c.es ?? c.en ?? "" };

      if (c && typeof c === "object") {
        return {
          ...c,
          name: isLangObj(c.name)
            ? c.name[L] ?? c.name.es ?? c.name.en ?? ""
            : c.name ?? "",
        };
      }

      return null;
    })
    .filter(Boolean);
};

// =====================
// Normalización de KEYS para Specs
// =====================
const SPEC_KEY_ALIASES = {
  usableWidth: ["anchoutil", "anchoUtil", "usablewidth", "usableWidth", "usefulwidth", "effectivewidth"],
  loadCapacity: ["pesoresiste", "pesoResiste", "loadcapacity", "loadCapacity", "resistance", "capacidad"],
  weightPerM2: ["pesoporm2", "pesoPorM2", "weightperm2", "weightPerM2", "kgm2", "kg/m2"],
  length: ["length", "largo", "longitud", "len"],
  width: ["width", "ancho", "anchura"],
  thickness: ["thickness", "espesor", "grosor"],
  weight: ["weight", "peso"],
  composition: ["composition", "composicion", "composición", "material", "composicionmaterial"],
  serviceLife: ["serviceLife", "vidautil", "vidaÚtil", "vida útil", "lifespan", "life"],
  certifications: ["certifications", "certificaciones", "certificacion", "certificación"],
  installation: ["installation", "instalacion", "instalación", "montaje"],
  coverage: ["coverage", "cubrimiento", "cobertura"],
  package: ["package", "empaque", "caja", "cajas"],
};

const normalizeSpecKey = (key) => {
  const raw = String(key || "").trim();
  const k = raw
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "");

  for (const [canonical, list] of Object.entries(SPEC_KEY_ALIASES)) {
    const isMatch = list.some(
      (x) => k === String(x).toLowerCase().replace(/\s+/g, "")
    );
    if (isMatch) return canonical;
  }
  return raw;
};

const mapSpecs = (specs, lang) => {
  if (!specs || typeof specs !== "object") return specs;

  const out = {};
  for (const [k, v] of Object.entries(specs)) {
    const canonKey = normalizeSpecKey(k);
    if (Array.isArray(v)) out[canonKey] = v.map((x) => pickLang(x, lang));
    else out[canonKey] = pickLang(v, lang);
  }
  return out;
};

// Export para usar en ProductModule
export const localizeProduct = (product, lang = "es") => {
  if (!product) return product;

  const L = normalizeLang(lang);

  return {
    ...product,
    title: pickLang(product.title, L),
    description: pickLang(product.description, L),
    ctaText: pickLang(product.ctaText, L),
    benefits: pickArray(product.benefits, L),
    applications: pickArray(product.applications, L),
    colors: mapColors(product.colors, L),
    accesorios: pickArray(product.accesorios, L),
    specs: mapSpecs(product.specs, L),
    composition: Array.isArray(product.composition)
      ? product.composition.map((x) => ({
          ...x,
          label: pickLang(x.label, L),
        }))
      : product.composition,
  };
};

export function getProductBySlug(slug) {
  if (!slug) return undefined;
  const s = decodeURIComponent(String(slug).trim().toLowerCase());
  return PRODUCTS[s];
}

export const listProducts = () => Object.values(PRODUCTS);
export const listByCategory = (category) =>
  listProducts().filter((p) => p.category === category);
export const listBySubcategory = (category, subcategory) =>
  listProducts().filter((p) => p.category === category && p.subcategory === subcategory);

// (si luego querés usar slugify en UI/links, ya lo tenés arriba)
